<template>
  <div class="d-flex align-items-center p-0" v-if="account">
    <img v-if="showIcon" class="account-currency-icon" :src="helper.currencyIcon(account.currency)" :alt="account.currency">
    <div class="account-sum" :class="{'m-0': !showIcon}">
      <div class="text-secondary" v-if="showId">
        <small v-b-tooltip.hover :title="account.id">{{ account.id.substring(0, 8) }}</small> <copy-button :value="account.id"></copy-button>
      </div>
      <span class="account-amount text-nowrap">{{ numberFormatter.formatNumber(account.sumWithoutInsurance) }} {{ account.sumWithoutInsurance.currency }}</span>
      <div class="d-flex flex-row align-items-center">
        <small class="text-danger me-1" v-b-tooltip.hover :title="helper.trans('labels.insurance_warning', { sum: numberFormatter.formatNumber(account.insuranceLimitSum.amount, 2) + ' ' +  account.insuranceLimitSum.currency})" v-if="!hideInsurance && account.insuranceLimitReach"><i class="fa fa-warning"></i></small>
        <span v-if="!hideInsurance"  style="font-size: 70%;" :class="{'text-success': !account.insuranceLimitReach, 'text-danger': account.insuranceLimitReach}" >{{ helper.trans('labels.insurance_limit')}}: {{ numberFormatter.formatNumber(account.insuranceSum.amount, 2) }} / {{ numberFormatter.formatNumber(account.insuranceLimitSum.amount, 2) }} {{ account.insuranceLimitSum.currency }}</span>
      </div>

      <span class="on-hold">{{ helper.trans("dashboard.on_hold") }}: {{ numberFormatter.formatNumber(account.frozenSum) }} {{ account.sum.currency }}</span>
      <span v-if="isAdmin && parseFloat(account.correctionSum.amount) !== 0" class="correction">{{ helper.trans("dashboard.correction") }}: {{ numberFormatter.formatNumber(account.correctionSum) }} {{ account.sum.currency }}</span>
      <span v-if="account.externalDepositSum" class="on-hold">{{ helper.trans("dashboard.external_deposit") }}: {{ numberFormatter.formatNumber(account.externalDepositSum) }} {{ account.externalDepositSum?.currency }}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import AccountDTO from "@/models/AccountDTO";
import CopyButton from "@/components/CopyButton.vue";
import {useStore} from "vuex";

export default defineComponent({
  name: "AccountWidget",
  props: {
    showId: {
      type: Boolean as PropType<boolean>,
      default: false
    } as Prop<boolean>,
    showIcon: {
      type: Boolean as PropType<boolean>,
      default: false
    } as Prop<boolean>,
    hideInsurance: {
      type: Boolean as PropType<boolean>,
      default: false
    } as Prop<boolean>,
    account: {
      type: Object as PropType<AccountDTO>,
    } as Prop<AccountDTO>
  },
  components: {
    CopyButton
  },
  setup() {
    const store = useStore()

    return {
      helper,
      numberFormatter,
      isAdmin: computed(() => store.getters.isAdmin),
    }
  }
})
</script>
